export default import.meta.ROLLUP_FILE_URL_cag8FOTGiHYJetG90QTjWw